import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getPhotoCaptureQuestionnaireId, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, photoCaptureUpdateContextDataAction, getPhotoCaptureIsTermsAndConditionAccepted, getPhotoCaptureImageMaxWidth, AdditionalPhotosComponent, photoCaptureAttachmentDataAction, getPhotoCaptureAttachmentInfo, getPhotoCaptureContextId, photoCaptureResetContextAction, photoCaptureFileUploadFailedAction, getPhotoCaptureAssignmentSubType, getPhotoCaptureAssignmentType, photoCaptureIsFileUploadStartedAction, getPhotoCaptureDisableLibrary, photoCaptureUpdateAttachedArtifactIdSuccessAction, getPhotoCaptureAttachedArtifactIds, getPhotoCaptureFileSizeLimit, getPhotoCaptureCategories, getPersonaConfiguration, getShouldShowCommentBox, getMaxFileCount, getShouldAllowMitchellIntelligent } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationSaveRequestAction, questionnaireEvaluationQuestionGetAction, getQuestionnaireEvaluationParentQuestionId } from "../../../domain/questionnaireEvaluation";
import { closeFileUploadModalAction } from "../../../domain/file";
import { getGPCEvaluationDocId } from '../utilities';
import { getGPCTheme, getGPCAttachmentsFromQuestionnaireEvaluation } from '../selectors';
const mapStateToProps = (state) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        attachments: getGPCAttachmentsFromQuestionnaireEvaluation(state),
        contextId: getPhotoCaptureContextId(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        assignmentSubType: getPhotoCaptureAssignmentSubType(state),
        imageMaxWidth: getPhotoCaptureImageMaxWidth(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state),
        parentQuestionId: getQuestionnaireEvaluationParentQuestionId(state),
        fileSizeLimit: getPhotoCaptureFileSizeLimit(state),
        attachedArtifactIds: getPhotoCaptureAttachedArtifactIds(state),
        categories: getPhotoCaptureCategories(state),
        personaConfiguration: getPersonaConfiguration(state),
        shouldShowCommentBox: getShouldShowCommentBox(state),
        maxFileCount: getMaxFileCount(state),
        isMic: getShouldAllowMitchellIntelligent(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return Object.assign(Object.assign({}, bindActionCreators({
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureUpdateContextDataAction,
        photoCaptureAttachmentDataAction,
        photoCaptureResetContextAction,
        photoCaptureFileUploadFailedAction,
        photoCaptureIsFileUploadStartedAction,
        photoCaptureUpdateAttachedArtifactIdSuccessAction
    }, dispatch)), { onClose: () => dispatch(closeFileUploadModalAction()) });
};
export const ConnectedAdditionalPhotosComponent = connect(mapStateToProps, mapDispatchToProps)(AdditionalPhotosComponent);
//# sourceMappingURL=ConnectedAdditionalPhotosComponent.js.map